import { Skeleton } from "@mui/material";
import { ReactElement } from "react";
import { Container as GiftsContainer } from "../GiftSelection/styles";

const loop = (times: number, callback: (i: number) => ReactElement) => {
	return [...Array(times)].map((_, i) => callback(i));
};

export const GiftSelectionSkeleton = () => {
	return (
		<GiftsContainer>
			{loop(2, (i) => (
				<Skeleton
					key={`friend-shop-gift-skeleton-${i}`}
					animation="wave"
					variant="rectangular"
					width="20.44em"
					height="22.31em"
					sx={{ borderRadius: "18px" }}
				/>
			))}
		</GiftsContainer>
	);
};
